export default __webpack_public_path__ + "static/media/img6.bee4f71d.png";